import { AfterViewInit, Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import 'rxjs/add/operator/first';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-locations-data',
  templateUrl: './locations-data.component.html',
  styleUrls: ['./locations-data.component.css']
})
export class LocationsDataComponent implements OnInit, AfterViewInit, OnDestroy {
  showLoading = true;
  showSpinner = false;
  clientKey: string;
  clientData: Client;
  locationsData: LocationInfo[];
  removeListener: Function;
  locationKeys = [];
  locationOptions = [];
  locationNames = {};

  options = {
    key: environment.froalaKey,
    charCounterCount: true,
    htmlAllowedEmptyTags: ['div', 'textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.mdi'],
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlRemoveTags: [],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
    height: 100,
    heightMax: 100
  };

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public router: Router,
    private renderer: Renderer2,
    private dragulaService: DragulaService,
  ) {
    this.dragulaService.setOptions('group-bag', { revertOnSpill: true });
    this.dragulaService.setOptions('locations-ungrouped-bag', { revertOnSpill: true });
  }

  async ngOnInit() {
    this.clientKey = this.route.snapshot.params.key;
    this.clientData = await this._getClient();
    this.locationsData = await this._getLocations();
    this._checkVars();
    this.showLoading = false;
    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.save().then(() => this.afService.updateSettingsOnServer(this.clientData));
      }
    });
    this.dragulaService.dropModel.subscribe(domStuff => this.save());
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.removeListener();
    this.dragulaService.destroy('locations-ungrouped-bag');
    this.dragulaService.destroy('group-bag');
  }

  async save() {
    try {
      await this.afService.updateClient({
        locationsGroups: this.clientData.locationsGroups,
        locationsOrderType: this.clientData.locationsOrderType,
        locationsOrder: this.clientData.locationsOrder,
      }, this.clientKey);
      this.afService.openSnackBar('Location grouping and ordering successfully saved.');
    }
    catch (e) {
      console.error(e);
      this.afService.openSnackBar(e);
    }
  }

  private _checkVars() {
    let flag = false;
    _.each(this.locationsData, val => this.locationKeys.push(val.$key));
    _.each(this.locationsData, val => this.locationNames[val.$key] = val.name);
    _.each(this.locationsData, val => this.locationOptions.push({ label: val.name, value: val.$key }));

    if (!this.clientData.locationsOrderType) {
      flag = true;
      this.clientData.locationsOrderType = 'ungrouped';
    }
    if (!this.clientData.locationsGroups) {
      flag = true;
      this.clientData.locationsGroups = [];
    }
    if (!this.clientData.locationsGroupsLocationKeys) {
      flag = true;
      this.clientData.locationsGroupsLocationKeys = _.cloneDeep(this.locationKeys);
    }
    if (!this.clientData.locationsOrder) {
      flag = true;
      this.clientData.locationsOrder = _.cloneDeep(this.locationKeys);
    }
    else {
      let diff = _.xor(this.locationKeys, this.clientData.locationsOrder);
      if (diff.length > 0) {
        flag = true;
        if (this.locationKeys.length > this.clientData.locationsOrder.length) {
          // add missing locationKeys
          this.clientData.locationsOrder = [...this.clientData.locationsOrder, ...diff]
        }
        else {
          for (let d of diff) {
            // remove extra keys
            this.clientData.locationsOrder.splice(_.indexOf(this.clientData.locationsOrder, d), 1);
          }
          // check again!
          diff = _.xor(this.locationKeys, this.clientData.locationsOrder);
          if (diff.length > 0) {
            // add missing keys back
            this.clientData.locationsOrder = [...this.clientData.locationsOrder, ...diff]
          }
        }
      }
    }
    if (flag) {
      this.save();
    }
  }

  setSlug(group) {
    group.slug = group.title.replace(/\W+/g, '-').toLowerCase();
  }

  private _getClient(): Promise<Client> {
    return new Promise((resolve, reject) => {
      this.afService.getClientInfo(this.clientKey).first()
        .subscribe((data: Client) => resolve(data), error => reject(error));
    });
  }

  private _getLocations(): Promise<(LocationInfo)[]> {
    return new Promise((resolve, reject) => {
      this.afService.getLocationsByKey(this.clientKey).first()
        .subscribe((data: LocationInfo[]) => resolve(data), error => reject(error));
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/locations-data/locations-data.component.ts